<button mat-raised-button color="primary" (click)="triggerSaveQuoteModal()">
  <span>{{saveQuoteText}}</span>
</button>